// 过滤格式，移动端集联选择
export function generatePairsMobile(original, options) {
  const result = [];

  (original?.region ?? []).forEach((parent) => {
    const parentObj = options.find((r) => r.value === parent);

    if (parentObj && parentObj.children) {
      (original?.location ?? []).forEach((child) => {
        parentObj.children.find((c) => {
          if (c.value === child) {
            result.push(c);
          }
        });
      });
    }
  });

  return result;
}

// 还原格式移动端
export function restoreOriginalObjectMobile(values, options) {
  const originalObject = {
    region: new Set(), // 使用 Set 来确保唯一性
    location: new Set()
  };

  values.forEach((value) => {
    options.forEach((option) => {
      const isSame = option.children.find((child) => child.value === value.value);
      if (isSame) {
        originalObject.region.add(option.value); // Set 会自动去重
        originalObject.location.add(isSame.value);
      }
    });
  });

  return {
    region: Array.from(originalObject.region), // 转换 Set 为数组
    location: Array.from(originalObject.location)
  };
}
